<template>
    <tr>
        <td>
            <img :src="static + banner.url" width="300" />
        </td>
        <td class="text-center">
            <button
                class="btn btn-danger btn-image btn-sm"
                @click="removeBanner()"
            >
                <i class="fa fa-times"></i>
            </button>
        </td>
    </tr>
</template>

<script>
export default {
    props: ["banner", "banners", "static"],
    methods: {
        removeBanner() {
            if (confirm("¿Está seguro que quiere eliminar este banner?")) {
                this.banners.splice(this.banners.indexOf(this.banner), 1);
            }
        },
    },
};
</script>
